import {
	FallbackStrategy,
	MetaSiteModel,
	SiteAssetsClient,
	siteAssetsClientBuilder,
	SiteAssetsCollaborators,
	SiteAssetsSiteModels,
	SitePagesModel,
} from 'site-assets-client'
import { ProcessLevelSiteAssetsClientFactory, TBSiteAssetsRequest } from './types'
import { toSiteAssetsRequest } from './toSiteAssetsRequest'
import { toMetaSiteModel, toSitePagesModel } from './toSiteAssetsModel'
import { nopSiteAssetsMetricsReporter } from './nopSiteAssetsMetricsReporter'
import { toSiteAssetsHttpClient } from './toSiteAssetsHttpClient'

export const SiteAssetsClientAdapterFactoryImpl: ProcessLevelSiteAssetsClientFactory = ({
	fetchFn,
	config,
	siteAssetsMetricsReporter = nopSiteAssetsMetricsReporter(),
	manifests,
	moduleFetcher,
}) => ({
	dataFixersParams,
	requestUrl,
	siteScopeParams,
	beckyExperiments,
	fallbackOverride,
	staticHTMLComponentUrl,
	remoteWidgetStructureBuilderVersion,
	deviceInfo,
	qaMode,
}) => {
	const collaborators: SiteAssetsCollaborators = {
		httpClient: toSiteAssetsHttpClient(requestUrl, fetchFn, config.moduleTopology.environment.siteAssetsServerUrl),
		moduleFetcher,
		metricsReporter: siteAssetsMetricsReporter,
	}

	const sitePagesModel: SitePagesModel = toSitePagesModel(dataFixersParams, siteScopeParams)
	const metaSiteModel: MetaSiteModel = toMetaSiteModel(dataFixersParams, siteScopeParams)

	const siteAssetsSiteModels: SiteAssetsSiteModels = {
		sitePagesModel,
		metaSiteModel,
	}

	const siteAssetsClient: SiteAssetsClient = siteAssetsClientBuilder(collaborators, config, siteAssetsSiteModels)

	return {
		// result() returns a (Promise of) string or json depending on the content-type of the module output
		execute(request: TBSiteAssetsRequest, fallbackStrategy: FallbackStrategy): Promise<string | any> {
			return siteAssetsClient
				.execute(
					toSiteAssetsRequest(
						request,
						manifests.node.modulesToHashes,
						sitePagesModel.pageJsonFileNames,
						fallbackOverride ? fallbackOverride : fallbackStrategy,
						siteScopeParams,
						beckyExperiments,
						staticHTMLComponentUrl,
						remoteWidgetStructureBuilderVersion,
						deviceInfo,
						qaMode
					)
				)
				.then(({ result }) => result())
		},
		calcPublicModuleUrl(request: TBSiteAssetsRequest): string {
			return siteAssetsClient.getPublicUrl(
				toSiteAssetsRequest(
					request,
					manifests.node.modulesToHashes,
					sitePagesModel.pageJsonFileNames,
					/* TODO not relevant */ 'disable',
					siteScopeParams,
					beckyExperiments,
					staticHTMLComponentUrl,
					remoteWidgetStructureBuilderVersion,
					deviceInfo,
					qaMode
				)
			)
		},
		getInitConfig() {
			return config
		},
	}
}
